import React from 'react'
import { Card } from 'react-bootstrap'
import { AccordionSection, AccordionCard } from '../../accordion'
import { Tabs } from '@mmsg/louie'
import { formatCurrency } from '../../../helpers'
import LeaseFeesTable from './leaseFeesTable'

const FeesChargesWithTaxImplicatoinSection = (props) => {
  return (
    <>
      {props.totalFeeCharges > 0 && (
        <Card className="mb-13rem print-page-break-before">
          <Card.Header className="border-bottom-0 d-flex justify-content-between">
            <div className="text-header">Novated lease fees and charges</div>
            <div className="text-larger font-weight-bold">
              {formatCurrency(props.totalFeeCharges)}
            </div>
          </Card.Header>
          <Card.Body>
            <AccordionSection
              readerText="Novated lease fees and charges"
              expandAccordion={props.expandAccordion}
              title="In exchange for managing your novated lease account, there are a few fees and charges along the way. These are covered with your pre-tax income."
              hasTabs
            >
              <Tabs
                data={[
                  {
                    title: props.feesChargesPerPayData.payFrequency,
                    content: () => (
                      <LeaseFeesTable
                        nlFee={props.feesChargesPerPayData.nlFee}
                        spFee={props.feesChargesPerPayData.spFee}
                        id={`lease-fees-${props.feesChargesPerPayData.payFrequency}`}
                        brand={props.feesChargesPerPayData.brand}
                      />
                    ),
                  },
                  {
                    title: 'Annually',
                    content: () => (
                      <LeaseFeesTable
                        nlFee={props.feesChargesPerAnnumData.nlFee}
                        spFee={props.feesChargesPerAnnumData.spFee}
                        id={`lease-fees-Annually`}
                        brand={props.feesChargesPerAnnumData.brand}
                      />
                    ),
                  },
                ]}
                activeIndex={0}
                equalWidth
              />
            </AccordionSection>
          </Card.Body>
        </Card>
      )}
      {/* Novated lease fees and charges: End */}

      {/* TAX IMPLICATIONS AND OTHER CHARGES: Start */}
      {props.totalTaxImplication > 0 && (
        <Card className="mb-13rem print-page-break-before card-shadow">
          <Card.Header className="border-bottom-0 d-flex justify-content-between">
            <div className="text-header">
              Tax Implications and Other Charges
            </div>
            <div className="text-larger font-weight-bold">
              {formatCurrency(props.totalTaxImplication)}
            </div>
          </Card.Header>
          <Card.Body>
            <AccordionSection
              readerText="Tax Implications and Other Charges"
              expandAccordion={props.expandAccordion}
              title="Novated leasing includes a charge (or, depending on your circumstances, charges) determined by the ATO in exchange for the potential benefits you’ll receive."
              hasTabs
            >
              <Tabs
                data={[
                  {
                    title: props.feesChargesPerPayData.payFrequency,
                    content: () => (
                      <LeaseFeesTable
                        fbt={props.feesChargesPerPayData.fbt}
                        lcda={props.feesChargesPerPayData.lcda}
                        erShare={props.feesChargesPerPayData.erShare}
                        gstOnECM={props.feesChargesPerPayData.gstOnECM}
                        greenfleet={props.feesChargesPerPayData.greenfleet}
                        erAdminFee={props.feesChargesPerPayData.erAdminFee}
                        gstOnECM_isDisplayed={
                          props.feesChargesPerPayData.gstOnECM_isDisplayed
                        }
                        erShare_isDisplayed={
                          props.feesChargesPerPayData.isTaxShare
                        }
                        id={`lease-fees-${props.feesChargesPerPayData.payFrequency}`}
                        brand={props.feesChargesPerPayData.brand}
                      />
                    ),
                  },
                  {
                    title: 'Annually',
                    content: () => (
                      <LeaseFeesTable
                        fbt={props.feesChargesPerAnnumData.fbt}
                        lcda={props.feesChargesPerAnnumData.lcda}
                        erShare={props.feesChargesPerAnnumData.erShare}
                        gstOnECM={props.feesChargesPerAnnumData.gstOnECM}
                        greenfleet={props.feesChargesPerAnnumData.greenfleet}
                        erAdminFee={props.feesChargesPerAnnumData.erAdminFee}
                        gstOnECM_isDisplayed={
                          props.feesChargesPerAnnumData.gstOnECM_isDisplayed
                        }
                        erShare_isDisplayed={
                          props.feesChargesPerAnnumData.isTaxShare
                        }
                        id={`lease-fees-Annually`}
                        brand={props.feesChargesPerAnnumData.brand}
                      />
                    ),
                  },
                ]}
                activeIndex={0}
                equalWidth
              />
              {props.feesChargesPerPayData.lcda ? (
                <>
                  <AccordionCard
                    expandAccordion={props.expandAccordion}
                    className="mb-24"
                    title="Why am I being charged Luxury Car Depreciation Allowance (LCDA) but haven’t leased a luxury car?"
                  >
                    <p>
                      Even though you may not be leasing a vehicle which is
                      considered a luxury car by the Australian Tax Office, LCDA
                      is a cost recovered by Oly on behalf of your employer
                      for any amount you're financing that is greater than the
                      Luxury Vehicle Limit set by the ATO.
                    </p>
                  </AccordionCard>
                  <AccordionCard
                    expandAccordion={props.expandAccordion}
                    className="mb-24"
                    title="What’s the difference between Luxury Car Tax and LCDA?"
                  >
                    <p>
                      Luxury Car Tax is an amount required to be collected by
                      the dealer on behalf of the ATO, whereas LCDA is an amount
                      collected by Oly on behalf of your employer.
                    </p>
                  </AccordionCard>
                </>
              ) : null}
            </AccordionSection>
          </Card.Body>
        </Card>
      )}
    </>
  )
}

export default FeesChargesWithTaxImplicatoinSection
